import React from "react";
import {Modal, Form, Input} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";
import Select from "../../../../components/Select";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
    platform: number
}

function ModifyModal(props: ModifyModalProps) {

    const {form, platform, ...otherProps} = props
    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                {platform === 1 && (
                    <Form.Item label={'客户'} name={'dealerId'} rules={[{required: true, message: '请选择客户'}]}>
                        <Select url={'/dealer/dict'} getData={data => data.data} textField={'name'} valueField={'id'}/>
                    </Form.Item>
                )}
                <Form.Item label={'姓名'} name={'nickName'} rules={[{required: true, message: '请输入姓名'}]}>
                    <Input/>
                </Form.Item>
                {platform === 0 && (
                    <>
                        <Form.Item label={'用户名'} name={'userName'}
                                   rules={[{required: true, message: '请输入用户名'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label={'OA ID'} name={'oaId'}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label={'部门OA ID'} name={'oaDepartmentId'}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label={'成本中心'} name={'costCenter'}>
                            <Input/>
                        </Form.Item>
                    </>
                )}
                <Form.Item label={'电话'} name={'phone'} rules={[{required: true, message: '请输入电话'}]}
                           normalize={value => value.replace(/\s*/g, "")}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'邮箱'} name={'email'} rules={[
                    {pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '请入正确的邮箱地址'}
                ]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'角色'} name={'roleIds'}>
                    <Select url={`/role/?platform=${platform}`}
                            textField={'name'}
                            valueField={'id'}
                            getData={(data: any) => data.data}
                            mode={"multiple"}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
